/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteS3ProfilePhotoAdmin} from '../api'

export const useMutationDeleteS3ProfilePhotoAdmin = createReactQueryMutationHook('deleteS3ProfilePhotoAdmin', deleteS3ProfilePhotoAdmin)
